import {
  TbBan, TbCircleCheck, TbClockHour4, TbAlertTriangle, TbCalendarEvent, TbCircleMinus, TbHelpCircle, TbCircleDashed,
} from 'react-icons/tb';
import { membershipStatus } from '../lib/format';

const ICONS = {
  active: TbCircleCheck,
  pending: TbClockHour4,
  overdue: TbAlertTriangle,
  upcoming: TbCalendarEvent,
  expired: TbCircleMinus,
  voided: TbBan,
  none: TbCircleDashed,
  unknown: TbHelpCircle,
};

/**
 * Membership status as text + icon + color (spec: "Estados de cuota con
 * texto e icono además del color"). The label is the accessible content; the
 * icon is decorative so it never gets announced twice.
 */
export function StatusBadge({ status }) {
  const { code, label, tone } = membershipStatus(status);
  const Icon = ICONS[code] || TbHelpCircle;
  return (
    <span className={`gym-badge gym-badge--${tone}`}>
      <Icon aria-hidden="true" focusable="false" />
      <span>{label}</span>
    </span>
  );
}
